import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import ProductContext from '../../contexts/ProductContext';
import { ChevronDown } from '../../components/ui/Icons';

export default function ProductInfo() {
  const { product, translates } = useContext(ProductContext);

  const productInfoDiv = useRef<HTMLDivElement>(null);
  const productSpecsDiv = useRef<HTMLDivElement>(null);
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [showMoreButtonInfo, setShowMoreButtonInfo] = useState(false);

  const { productBigInfo, productSpecs } = product;
  const { products } = translates;

  const [showMoreSpecs, setShowMoreSpecs] = useState(false);
  const [showMoreButtonSpecs] = useState(productSpecs.length > 3);

  useEffect(() => {
    if (productInfoDiv.current) {
      const productInfoHeight = productInfoDiv.current.offsetHeight;
      if ((productInfoHeight / 31.5) > 6) {
        setShowMoreButtonInfo(true);
      }
    }
  }, [productInfoDiv]);
  return (
    <div id="product-info" className="product-info lg:px-6 xl:px-11.7">
      <div className="pt-8 lg:pt-12 lg:pr-6">
        {productBigInfo && (
          <Disclosure as="div" className="mb-8 md:mb-16 lg:mb-24 last:mb-0" defaultOpen>
            <DisclosureButton as="h3" className="group flex items-center w-full justify-between text-2xl-secondary lg:text-4xl leading-tight gap-x-2.5 text-left transition-colors cursor-pointer hover:text-light-grey-3" id="product-info">
              {Craft.t(products, 'Informatie')}
              <ChevronDown className="group-data-[open]:rotate-180" />
            </DisclosureButton>
            <hr className="border-light-grey-1 mt-4 lg:mt-6" />
            <DisclosurePanel className="pt-4 md:pt-6 lg:pr-16" ref={productInfoDiv}>
              {/* eslint-disable-next-line react/no-danger */}
              <div className={!showMoreInfo && showMoreButtonInfo ? 'line-clamp-6' : ''} dangerouslySetInnerHTML={{ __html: productBigInfo }} />
              {showMoreButtonInfo && (
                <button
                  type="button"
                  className="btn btn-link btn-link-sm mt-4 group/btn"
                  onClick={() => {
                    setShowMoreInfo(!showMoreInfo);
                    if (productInfoDiv.current && productInfoDiv.current.parentElement) {
                      productInfoDiv.current.parentElement.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  {showMoreInfo ? Craft.t(products, 'Lees minder') : Craft.t(products, 'Lees meer')}
                  <ChevronDown className={`group-hover/btn:translate-x-0 ${showMoreInfo ? 'rotate-180' : ''}`} />
                </button>
              )}
            </DisclosurePanel>
          </Disclosure>
        )}
        {productSpecs.length > 0 && (
          <Disclosure as="div" className="mb-8 md:mb-16 lg:mb-24 last:mb-0" defaultOpen ref={productSpecsDiv}>
            <DisclosureButton as="h3" className="group flex items-center w-full justify-between text-2xl-secondary lg:text-4xl leading-tight gap-x-2.5 text-left transition-colors cursor-pointer hover:text-light-grey-3" id="product-specs">
              {Craft.t(products, 'Specificaties')}
              <ChevronDown className="group-data-[open]:rotate-180" />
            </DisclosureButton>
            <DisclosurePanel className="pt-8 md:pt-6">
              <div className="group/load-more">
                <div className="flex flex-col gap-y-3 lg:gap-y-6 p-4 lg:py-6 rounded-lg bg-light-shade-1 text-sm lg:text-base leading-normal">
                  {Object.entries(productSpecs.reduce((acc, spec) => {
                    if (!acc[spec.name]) {
                      acc[spec.name] = [];
                    }
                    acc[spec.name].push(spec.value);
                    return acc;
                  }, {} as Record<string, string[]>))
                    .map(([name, values], index) => (
                      <div className={`lg:gap-x-2.5 ${!showMoreSpecs && showMoreButtonSpecs && index > 2 ? 'hidden' : 'lg:flex'}`} key={name}>
                        <span className="block lg:w-2/5 xl:w-1/4 font-semibold text-base lg:text-lg">{name}</span>
                        <span className="block lg:w-3/5 xl:w-3/4">{values.join(', ')}</span>
                      </div>
                    ))}
                </div>
                {showMoreButtonSpecs && (
                  <button
                    type="button"
                    className="btn btn-link btn-link-sm mt-4 group/btn"
                    onClick={() => {
                      setShowMoreSpecs(!showMoreSpecs);
                      if (productSpecsDiv.current) {
                        productSpecsDiv.current.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    {showMoreSpecs ? Craft.t(products, 'Lees minder') : Craft.t(products, 'Lees meer')}
                    <ChevronDown className={`group-hover/btn:translate-x-0 ${showMoreSpecs ? 'rotate-180' : ''}`} />
                  </button>
                )}
              </div>
            </DisclosurePanel>
          </Disclosure>
        )}
      </div>
    </div>
  );
}
